<div class="container-fluid">
  <div class="row team-info-row">
    <div class="col s12 m4 l4 xl6">
      <h1>Team info</h1>
    </div>
    <div class="col s12 m8 l8 xl6 add-btn-container">
      <div class="rounded-lg transition-all duration-300 ease-out origin-right w-full lg:w-80 !h-[45px]">
        <app-employee-search [placeholder]="'Search Team'" [isInputSearch]="true" 
          [initialValue]="searchQuery" (searchEmployeeName)="searchTeams($event)"
          class="!w-full !h-full">
        </app-employee-search>
      </div>
      <span>
        <button mat-raised-button class="employee-add-btn !h-[45px]"
          [disabled]="!isTourActive() || !canAddTeam"
          (click)="openUserModal()"
          tourAnchor="addNewTeam" *ngIf="isAdmin || !isTourActive()">
          <span class="material-symbols-outlined"> person_add </span>
          Add Team
        </button>
      </span>
    </div>
  </div>

  <div class="row" *ngIf="teamLimitMessage">
    <div class="col s12">
      <p class="team-limit-banner">
        {{ teamLimitMessage }}
        <a routerLink="/billings" [queryParams]="{ intent: 'upgrade' }">Upgrade product tier</a>
      </p>
    </div>
  </div>

  <div class="row sectionParts"
    [ngClass]="{'empty-state-equal-height': (!groupList || groupList.length === 0) && (!teamData || teamData.length === 0)}">
    <div class="col s12 m12 l12 xl5 app-team-list-col" tourAnchor="ListOfTeam">
      <app-team-list [loading]="loading" [groupList]="groupList" (goToList)="handleDataFromTeamMem($event)"
        [selectedTeamData]="selectedTeam" [isAdmin]="isAdmin"></app-team-list>
    </div>

    <div class="col s12 m12 l12 xl7 app-team-member-list-col" tourAnchor="ListOfEmployeeOfTeam">
      <app-team-member-list [loading]="loading" [groupList]="groupList" [teamData]="teamData"></app-team-member-list>
    </div>
  </div>
</div>